import { StorageKeys } from '../types/storage';

export const isAuthenticated = (): boolean => {
  const token = localStorage.getItem(StorageKeys.TOKEN);
  return token !== null && token.trim() !== '';
};
